/*
 * Sepete ekle -> sayfada kal, kucuk bir bildirim goster.
 *
 * 21 Ekim 2026'da istendi. Temanin iki secenegi var, ikisi de istenmedi:
 *   - "drawer": sagdan cekmece aciliyor. Cekmecedeki "Odemeye gec" il/ilce ve
 *     kurumsal fatura alanlarini atliyor; bu alanlar yalnizca sepet sayfasinda.
 *   - "page": urun eklenince sepet sayfasina gidiliyor; musteri alisverise
 *     devam etmek isteyebilir.
 * Tema ayari "page" yapildi (sepet simgesi dogrudan sepet sayfasina gidiyor,
 * cekmece hic basilmiyor), ekleme ise burada sayfadan cikmadan yapiliyor.
 *
 * Tema ayari tekrar "drawer" yapilirsa bu dosya devreden cikar, temanin
 * kendi cekmecesi calisir. Sepet sayfasinda da devreye girmez: orada formun
 * normal gonderimi sayfayi yeniler, sepet listesi guncel kalir.
 *
 * Temanin `product-form` elemani "page" modunda gonderimi hic durdurmuyor
 * (theme.js: `if (cartType === 'page') return;`). Burada gonderim belge
 * duzeyinde, yakalama asamasinda durduruluyor; temanin dosyalarina dokunulmadi.
 */
(() => {
  const tema = window.FoxTheme;
  if (!tema || !tema.settings || tema.settings.cartType !== 'page') return;

  const sepetYolu = (tema.routes && tema.routes.cart_url) || '/cart';
  const eklemeYolu = (tema.routes && tema.routes.cart_add_url) || '/cart/add';
  if (location.pathname.replace(/\/$/, '') === sepetYolu.replace(/\/$/, '')) return;

  const SURE = 4500;
  let kutu = null;
  let zamanlayici = null;

  const kutuyuKur = () => {
    if (kutu) return kutu;
    kutu = document.createElement('div');
    kutu.className = 'nm-atc-toast no-empty';
    kutu.setAttribute('role', 'status');
    kutu.setAttribute('aria-live', 'polite');
    kutu.hidden = true;
    kutu.innerHTML = `
      <span class="nm-atc-toast__ikon" aria-hidden="true">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
      </span>
      <span class="nm-atc-toast__metin">
        <strong class="nm-atc-toast__baslik"></strong>
        <span class="nm-atc-toast__urun"></span>
      </span>
      <a class="nm-atc-toast__git" href="${sepetYolu}">Sepete git</a>
      <button type="button" class="nm-atc-toast__kapat" aria-label="Kapat">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"></path></svg>
      </button>`;
    kutu.querySelector('.nm-atc-toast__kapat').addEventListener('click', gizle);
    kutu.addEventListener('mouseenter', () => clearTimeout(zamanlayici));
    kutu.addEventListener('mouseleave', () => zamanla());
    document.body.appendChild(kutu);
    return kutu;
  };

  // Baslik yapiskan; bildirim onun hemen altinda dursun, ustune binmesin.
  const ustBosluk = () => {
    const baslik = document.querySelector('.shopify-section-group-header-group header, header.header');
    const alt = baslik ? baslik.getBoundingClientRect().bottom : 0;
    return Math.max(12, Math.round(alt) + 12);
  };

  const zamanla = () => {
    clearTimeout(zamanlayici);
    zamanlayici = setTimeout(gizle, SURE);
  };

  function gizle() {
    clearTimeout(zamanlayici);
    if (!kutu || kutu.hidden) return;
    kutu.classList.remove('is-acik');
    setTimeout(() => {
      if (!kutu.classList.contains('is-acik')) kutu.hidden = true;
    }, 200);
  }

  const goster = (baslik, urun, hata) => {
    const k = kutuyuKur();
    k.classList.toggle('nm-atc-toast--hata', !!hata);
    k.querySelector('.nm-atc-toast__baslik').textContent = baslik;
    const urunAlani = k.querySelector('.nm-atc-toast__urun');
    urunAlani.textContent = urun || '';
    urunAlani.hidden = !urun;
    k.style.setProperty('--nm-toast-top', `${ustBosluk()}px`);
    k.hidden = false;
    requestAnimationFrame(() => k.classList.add('is-acik'));
    zamanla();
  };

  const sepetiYay = async (eklenen) => {
    try {
      const sepet = await (await fetch(`${sepetYolu}.js`, { headers: { Accept: 'application/json' } })).json();
      // Baslik sayaci (cart-count) ve sepete bagli diger tema parcalari bunu dinliyor.
      if (tema.pubsub) tema.pubsub.publish(tema.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: sepet });
    } catch (e) {
      /* sayac guncellenmezse urun yine sepette; sayfa yenilenince duzelir */
    }
    if (eklenen) document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: eklenen } }));
  };

  document.addEventListener(
    'submit',
    async (olay) => {
      const form = olay.target;
      if (!(form instanceof HTMLFormElement) || form.getAttribute('is') !== 'product-form') return;
      if (olay.defaultPrevented) return;

      // "Islemde mi" sorusu formun KENDI dugmesine soruluyor, basilan dugmeye
      // degil — tema da boyle yapiyor. Urun sayfasindaki yapiskan cubugun
      // dugmesi formun disinda (`form=` ile bagli) ve tiklandigi anda kendini
      // aria-disabled yapiyor; basilan dugmeye bakinca ekleme hic yapilmiyordu
      // (21 Ekim, canlida yakalandi).
      const formDugmesi = form.querySelector('[type="submit"]');
      const dugmeler = [...new Set([formDugmesi, olay.submitter].filter(Boolean))];
      olay.preventDefault();
      if (formDugmesi && formDugmesi.getAttribute('aria-disabled') === 'true') return;

      let veri;
      try {
        veri = new FormData(form, olay.submitter || undefined);
      } catch (e) {
        veri = new FormData(form);
      }

      dugmeler.forEach((d) => {
        d.setAttribute('aria-disabled', 'true');
        d.classList.add('btn--loading');
      });

      try {
        const yanit = await fetch(`${eklemeYolu}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: veri
        });
        const sonuc = await yanit.json();

        // Hata her zaman "hic eklenmedi" demek degil: stoktan fazla adet
        // istenirse Shopify stoktakini ekleyip 422 donuyor ("yalnizca 50 urun
        // eklendi", olculdu). Bu yuzden Shopify'in kendi cumlesi gosteriliyor
        // ve sayac yine de yenileniyor.
        if (!yanit.ok || sonuc.status) {
          goster('Dikkat', sonuc.description || sonuc.message || 'Ürün sepete eklenemedi.', true);
          sepetiYay(null);
          return;
        }

        const pencere = form.closest('quick-view-modal');
        if (pencere && typeof pencere.hide === 'function') pencere.hide(true);

        // "Birlikte Sepete Ekle" (Essential Upsell) urunleri kendi istegiyle
        // ekliyor, bu formun istegini yakalayip `{}` donduruyor (21 Ekim,
        // olculdu). Urun adi yok; urun satiri gizlenir, bildirim yine cikar.
        goster('Sepete eklendi', sonuc.product_title || sonuc.title || '');
        sepetiYay(sonuc);
      } catch (e) {
        // Ag hatasinda musteriyi ortada birakma: formu normal yoldan gonder.
        form.submit();
      } finally {
        dugmeler.forEach((d) => {
          d.classList.remove('btn--loading');
          d.removeAttribute('aria-disabled');
        });
      }
    },
    true
  );
})();
